import {isNotNil} from 'ramda';

import type {ActionPermission, Permission} from '@dms/api/shared';

export const isActionPermission = (item: Permission): item is ActionPermission =>
  isNotNil((item as ActionPermission).actionId);
